import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    address: '',
    chainId: '',
    walletVisible: false
  },
  mutations: {
    SET_WALLET(state, payload) { Object.assign(state, payload) },
    SET_WALLET_VISIBLE(state, value) { state.walletVisible = value }
  }
})
